export class Color {
    constructor(r: number, g: number, b: number, a: number | null | undefined = 255) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a ?? 255;
    }
    /**
     * Red value, from 0 to 255.
     */
    readonly r: number;
    /**
     * Green value, from 0 to 255.
     */
    readonly g: number;
    /**
     * Blue value, from 0 to 255.
     */
    readonly b: number;
    /**
     * Alpha (opacity) value, from 0 to 255.
     */
    readonly a: number;
}

export function hexToRgb(hex: string) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
    if (result) {
        // 6 or 8 hex digits
        return new Color(
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
            result.length > 4 && result[4] != null ? parseInt(result[4], 16) : 255,
        );
    }
    result = /^#?([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i.exec(hex);
    if (result) {
        // 3 or 4 hex digits
        return new Color(
            parseInt(result[1], 16) * 17,
            parseInt(result[2], 16) * 17,
            parseInt(result[3], 16) * 17,
            (result.length > 4 && result[4] != null ? parseInt(result[4], 16) : 15) * 17,
        );
    }
    throw "Invalid format";
}
